import axios from 'axios';
import { adminLogout } from 'src/redux/slices/adminAuth';
import { dispatch } from 'src/redux/store';

// const axiosAdminAuth = axios.create({ baseURL: 'http://localhost:3003' });
const axiosAdminAuth = axios.create({ baseURL: 'https://api.hopviagens.com.br' });

axiosAdminAuth.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response && response.status === 401) {
      dispatch(adminLogout());
    }
    return Promise.reject((response && response.data) || 'Something went wrong');
  }
);

export default axiosAdminAuth;
